module.exports = {"610831001":"双湖峪街道","610831101":"何家集镇","610831102":"老君殿镇","610831103":"裴家湾镇","610831104":"苗家坪镇","610831105":"三川口镇","610831106":"马蹄沟镇","610831107":"周家硷镇","610831108":"电市镇","610831109":"砖庙镇","610831110":"淮宁湾镇","610831111":"马岔镇","610831200":"驼耳巷乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/610831.json
// module id = 2871
// module chunks = 0